export enum NoteInstanceType {
	Note = 'Note',
	Notes = 'Notes'
}
